import { BrokerModel, ProfileModel } from 'dash-common';

import { DashboardNotificationsEnum } from './useCreateDashboardNotifications.constants';

export const checkIfBrokerInfoCompleted = (
  broker: BrokerModel | null,
  profile: ProfileModel | null
) => {
  if (!broker) return false;
  if (!profile?.firstName || !profile?.lastName) return false;
  if (!broker.agencyName) return false;
  if (!broker.agencyWebsite) return false;
  if (!broker.description) return false;

  return true;
};

export const setNotificationDismissTimestamp = (
  key: DashboardNotificationsEnum
) => {
  const notificationsDismissed = localStorage.getItem(
    'notificationsDismissedAt'
  );
  if (notificationsDismissed) {
    const notificationsDismissedParsed = JSON.parse(notificationsDismissed);
    notificationsDismissedParsed[key] = Date.now().toString();
    localStorage.setItem(
      'notificationsDismissedAt',
      JSON.stringify(notificationsDismissedParsed)
    );
  } else {
    localStorage.setItem(
      'notificationsDismissedAt',
      JSON.stringify({ [key]: Date.now().toString() })
    );
  }
};

export const removeNotificationDismissTimestamp = (
  key: DashboardNotificationsEnum
) => {
  const notificationsDismissed = localStorage.getItem(
    'notificationsDismissedAt'
  );
  if (notificationsDismissed) {
    const notificationsDismissedParsed = JSON.parse(notificationsDismissed);
    delete notificationsDismissedParsed[key];
    localStorage.setItem(
      'notificationsDismissedAt',
      JSON.stringify(notificationsDismissedParsed)
    );
  }
};

export const getNotificationDismissTimestamp = (
  key: DashboardNotificationsEnum
) => {
  const notificationsDismissed = localStorage.getItem(
    'notificationsDismissedAt'
  );
  if (notificationsDismissed) {
    const notificationsDismissedParsed = JSON.parse(notificationsDismissed);
    return notificationsDismissedParsed[key];
  }
  return null;
};

export const checkIfNotificationCanBeShown = (
  key: DashboardNotificationsEnum
) => {
  const timestamp = getNotificationDismissTimestamp(key);

  if (!timestamp) return true;

  const diff = Date.now() - timestamp;
  const showMessage = diff / (1000 * 60 * 60 * 24) > 1;

  return showMessage;
};
